module.exports = __webpack_public_path__ + "static/media/radiobutton_blue.e4f31d1c.svg";